import { cls } from "@wss/cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import React, { ComponentProps } from "react";
import ChildOrNull from "~/common/ChildOrNull";
type ProductDetailsCardPriceProps = ComponentProps<"p"> & {
  price: number;
  unitOfMeasure?: string;
  withSalePrice?: true;
};
export function ProductDetailsCardPrice({
  price,
  unitOfMeasure,
  ...rest
}: ProductDetailsCardPriceProps) {
  return <p {...rest} className={cls("mb-2 text-lg mx-auto h-min mt-auto text-red-500 font-semibold")} data-sentry-component="ProductDetailsCardPrice" data-sentry-source-file="Price.tsx">
      {formatAsCurrency.format(price)}
      <ChildOrNull condition={!!unitOfMeasure} data-sentry-element="ChildOrNull" data-sentry-source-file="Price.tsx">
        <span className="text-xs text-gray-800">/{unitOfMeasure}</span>
      </ChildOrNull>
    </p>;
}